(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-corporate-hero"] && !Shopify.designMode) return;
  try {
    
	document.addEventListener('click', function (event) {
		const opener = event.target.closest('[data-l-corp-popup]')
		if (opener) {
			const dialog = document.getElementById(opener.getAttribute('data-l-corp-popup'))
			if (!dialog || typeof dialog.showModal !== 'function') return
			event.preventDefault()
			const frame = dialog.querySelector('iframe')
			if (frame && !frame.getAttribute('src')) frame.setAttribute('src', frame.dataset.src)
			dialog.showModal()
			return
		}
		// Close on the close button, or on a click on the backdrop (the dialog itself, outside its content).
		const dialog = event.target.closest('.l-corp-hero__dialog')
		if (dialog && (event.target === dialog || event.target.closest('[data-l-corp-popup-close]'))) {
			dialog.close()
		}
	})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-featured-product-tabs"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-featured-product-tabs')) {
		class LTAFeaturedProductTabs extends HTMLElement {
			constructor() {
				super()
				this._boundHandlers = []
			}

			connectedCallback() {
				this._cacheElements()
				this._bindEvents()
			}

			disconnectedCallback() {
				this._unbindEvents()
			}

			_cacheElements() {
				this.tabEls = [...this.querySelectorAll('[data-fptab-tab]')]
				this.stabsGridEls = [...this.querySelectorAll('[data-fptab-stabs]')]
				this.productsSwiperEls = [...this.querySelectorAll('[data-fptab-products]')]
			}

			_setActive(el, isActive) {
				if (isActive) {
					el.setAttribute('data-active', 'true')
				} else {
					el.removeAttribute('data-active')
				}
			}

			_bindEvents() {
				this._unbindEvents()

				this.tabEls.forEach((tabEl) => {
					const handler = (event) => this._onTabClick(event, tabEl)
					tabEl.addEventListener('click', handler)
					this._boundHandlers.push({ el: tabEl, handler })
				})

				this.stabsGridEls.forEach((gridEl) => {
					gridEl.querySelectorAll('[data-fptab-subtab]').forEach((subtabEl) => {
						const handler = (event) => this._onSubtabClick(event, subtabEl)
						subtabEl.addEventListener('click', handler)
						this._boundHandlers.push({ el: subtabEl, handler })
					})
				})
			}

			_unbindEvents() {
				this._boundHandlers.forEach(({ el, handler }) => {
					el.removeEventListener('click', handler)
				})
				this._boundHandlers = []
			}

			_onTabClick(event, clickedTab) {
				event.preventDefault()

				const tabIndex = clickedTab.dataset.tabIndex
				if (tabIndex == null) return

				this.tabEls.forEach((tabEl) => {
					this._setActive(tabEl, tabEl === clickedTab)
				})

				this.stabsGridEls.forEach((gridEl) => {
					const isActive = gridEl.dataset.tabIndex === tabIndex
					gridEl.classList.toggle('l-hidden', !isActive)

					if (isActive) {
						const activeSubtab =
							gridEl.querySelector('[data-fptab-subtab][data-active="true"]') ||
							gridEl.querySelector('[data-fptab-subtab]')
						if (activeSubtab) this._activateSubtab(activeSubtab, tabIndex)
					}
				})
			}

			_onSubtabClick(event, clickedSubtab) {
				event.preventDefault()

				const tabIndex = clickedSubtab.dataset.tabIndex
				if (tabIndex == null) return

				this._activateSubtab(clickedSubtab, tabIndex)
			}

			_activateSubtab(subtabEl, tabIndex) {
				const subtabIndex = subtabEl.dataset.subtabIndex
				const gridEl = subtabEl.closest('[data-fptab-stabs]')

				gridEl?.querySelectorAll('[data-fptab-subtab]').forEach((slideEl) => {
					this._setActive(slideEl, slideEl === subtabEl)
				})

				this._activateProductSwiper(tabIndex, subtabIndex)
			}

			_activateProductSwiper(tabIndex, subtabIndex) {
				const activeSwiperEl = this.productsSwiperEls.find(
					(swiperEl) => swiperEl.dataset.tabIndex === tabIndex && swiperEl.dataset.subtabIndex === subtabIndex
				)
				if (!activeSwiperEl) return

				const previousSwiperEl = this.querySelector('[data-fptab-products][data-active="true"]')
				if (activeSwiperEl === previousSwiperEl) return

				this.productsSwiperEls.forEach((swiperEl) => {
					const isActive = swiperEl === activeSwiperEl
					swiperEl.classList.toggle('l-hidden', !isActive)
					this._setActive(swiperEl, false)
				})

				activeSwiperEl.classList.remove('l-hidden')

				requestAnimationFrame(() => {
					this._setActive(activeSwiperEl, true)

					requestAnimationFrame(() => {
						activeSwiperEl?.swiperCarousel?.update?.()
					})
				})
			}
		}

		customElements.define('l-featured-product-tabs', LTAFeaturedProductTabs)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-hp-about-us"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-hp-about-us')) {
		class LTAHpAboutUs extends HTMLElement {
			constructor() {
				super()
				this._boundHandlers = []
			}

			connectedCallback() {
				this._cacheElements()
				this._bindEvents()
			}

			disconnectedCallback() {
				this._unbindEvents()
			}

			_cacheElements() {
				this.logoEls = [...this.querySelectorAll('[data-hpab-logo]')]
				this.mediaEls = [...this.querySelectorAll('[data-hpab-media]')]
				this.contentEls = [...this.querySelectorAll('[data-hpab-content]')]
			}

			_bindEvents() {
				this._unbindEvents()

				// Hover only on devices that support it; touch devices change on tap (click).
				const canHover = window.matchMedia('(hover: hover)').matches

				this.logoEls.forEach((logoEl) => {
					const clickHandler = (event) => {
						event.preventDefault()
						this._activateSlide(logoEl.dataset.slideId)
					}
					const keydownHandler = (event) => {
						if (event.key !== 'Enter' && event.key !== ' ') return
						event.preventDefault()
						this._activateSlide(logoEl.dataset.slideId)
					}

					logoEl.addEventListener('click', clickHandler)
					logoEl.addEventListener('keydown', keydownHandler)
					this._boundHandlers.push(
						{ el: logoEl, type: 'click', handler: clickHandler },
						{ el: logoEl, type: 'keydown', handler: keydownHandler }
					)

					if (canHover) {
						const mouseenterHandler = () => this._activateSlide(logoEl.dataset.slideId)
						logoEl.addEventListener('mouseenter', mouseenterHandler)
						this._boundHandlers.push({ el: logoEl, type: 'mouseenter', handler: mouseenterHandler })
					}
				})
			}

			_unbindEvents() {
				this._boundHandlers.forEach(({ el, type, handler }) => {
					el.removeEventListener(type, handler)
				})
				this._boundHandlers = []
			}

			_setActive(el, isActive) {
				if (isActive) {
					el.setAttribute('data-active', 'true')
				} else {
					el.removeAttribute('data-active')
				}
			}

			_activateSlide(slideId) {
				if (!slideId) return

				this.logoEls.forEach((logoEl) => {
					const isActive = logoEl.dataset.slideId === slideId
					logoEl.classList.toggle('is-active', isActive)
					this._setActive(logoEl, isActive)
				})

				this.mediaEls.forEach((mediaEl) => {
					const isActive = mediaEl.dataset.slideId === slideId
					this._setActive(mediaEl, isActive)
				})

				this.contentEls.forEach((contentEl) => {
					const isActive = contentEl.dataset.slideId === slideId
					this._setActive(contentEl, isActive)
				})
			}
		}

		customElements.define('l-hp-about-us', LTAHpAboutUs)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-hp-our-story"] && !Shopify.designMode) return;
  try {
    
	/**
	 * HP Our Story — subtle scroll parallax.
	 * The back (main) image drifts slowly, the front (small) image faster, and the
	 * text moves a touch — driven by GSAP ScrollTrigger scrub (already loaded site-wide).
	 *
	 * - Progressive enhancement: if GSAP/ScrollTrigger isn't ready, the user prefers
	 *   reduced motion, or the viewport is below 768px, nothing animates and the
	 *   layout renders exactly as-is.
	 * - Animates the inner <picture> elements (not the small-image wrapper, which owns
	 *   its own positioning transform), so no transform is clobbered.
	 */
	if (!customElements.get('l-hp-our-story')) {
		class LTAHpOurStory extends HTMLElement {
			connectedCallback() {
				this._ctx = null
				this._tryInit()
				// gsap/a-animation.js are deferred and may load after this element
				// connects; retry once everything has loaded.
				if (!this._ctx) {
					this._onLoad = this._tryInit.bind(this)
					window.addEventListener('load', this._onLoad, { once: true })
				}
			}

			disconnectedCallback() {
				if (this._onLoad) window.removeEventListener('load', this._onLoad)
				if (this._ctx) {
					this._ctx.revert()
					this._ctx = null
				}
			}

			_tryInit() {
				if (this._ctx || !window.gsap || !window.ScrollTrigger) return

				var gsap = window.gsap
				// Ensure the ScrollTrigger plugin is registered before building tweens.
				// a-animation.js also registers it, but script load order isn't
				// guaranteed; without registration GSAP silently ignores the
				// scrollTrigger config and the tween just plays once on load.
				gsap.registerPlugin(window.ScrollTrigger)

				var section = this
				// The wave SVG is a sibling of this element, so scope lookups to the
				// section wrapper (shared parent) to reach every parallax target.
				var root = this.parentElement || this
				var back = root.querySelector('[data-hpos-parallax="back"]')
				var front = root.querySelector('[data-hpos-parallax="front"]')
				var text = root.querySelector('[data-hpos-parallax="text"]')
				var wave = root.querySelector('[data-hpos-parallax="wave"]')

				// distance = total peak-to-peak travel (px); bigger = appears faster.
				// dir = scroll direction: -1 rises as you scroll down, +1 descends.
				var layers = [
					{ el: back, distance: 90, dir: 1 }, // large image drifts down
					{ el: front, distance: 200, dir: -1 }, // small image rises (opposite)
					{ el: text, distance: 50, dir: -1 }, // text rises gently with the front
					{ el: wave, distance: 120, dir: -1 }, // background line drifts up
				]

				this._ctx = gsap.matchMedia()
				this._ctx.add('(min-width: 768px) and (prefers-reduced-motion: no-preference)', function () {
					layers.forEach(function (layer) {
						if (!layer.el) return

						gsap.fromTo(
							layer.el,
							{ y: (-layer.dir * layer.distance) / 2 },
							{
								y: (layer.dir * layer.distance) / 2,
								ease: 'none',
								scrollTrigger: {
									trigger: section,
									start: 'top bottom',
									end: 'bottom top',
									scrub: 0.6,
								},
							}
						)
					})
				})
			}
		}

		customElements.define('l-hp-our-story', LTAHpOurStory)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-product-recommendations"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-product-recommendations-tabs')) {
		class LTAProductRecommendationsTabs extends HTMLElement {
			constructor() {
				super()
				this._boundHandlers = []
				this._recentlyViewedLoaded = false
			}

			connectedCallback() {
				this._cacheElements()
				this._bindEvents()
				this._trackCurrentProduct()
				this._checkRecentlyViewedAvailability()
			}

			disconnectedCallback() {
				this._unbindEvents()
			}

			_cacheElements() {
				this.tabEls = [...this.querySelectorAll('[data-prec-tab]')]
				this.panelEls = [...this.querySelectorAll('[data-prec-panel]')]
				this.recentlyViewedEl = this.querySelector('l-recently-viewed-products')
			}

			_setActive(el, isActive) {
				if (isActive) {
					el.setAttribute('data-active', 'true')
				} else {
					el.removeAttribute('data-active')
				}
			}

			_bindEvents() {
				this._unbindEvents()

				this.tabEls.forEach((tabEl) => {
					const handler = (event) => this._onTabClick(event, tabEl)
					tabEl.addEventListener('click', handler)
					this._boundHandlers.push({ el: tabEl, handler })
				})
			}

			_unbindEvents() {
				this._boundHandlers.forEach(({ el, handler }) => {
					el.removeEventListener('click', handler)
				})
				this._boundHandlers = []
			}

			_onTabClick(event, clickedTab) {
				event.preventDefault()

				const tabId = clickedTab.dataset.tabId
				if (!tabId) return

				this.tabEls.forEach((tabEl) => {
					this._setActive(tabEl, tabEl === clickedTab)
				})

				this.panelEls.forEach((panelEl) => {
					const isActive = panelEl.dataset.tabId === tabId
					panelEl.classList.toggle('l-hidden', !isActive)
					this._setActive(panelEl, isActive)
				})

				if (tabId === 'recently-viewed') {
					this._loadRecentlyViewed()
				}

				this._activatePanelSwiper(tabId)
			}

			_activatePanelSwiper(tabId) {
				const activePanel = this.panelEls.find((panelEl) => panelEl.dataset.tabId === tabId)
				const swiperEls = activePanel ? [...activePanel.querySelectorAll('[data-prec-products]')] : []

				swiperEls.forEach((swiperEl) => {
					this._setActive(swiperEl, false)
				})

				requestAnimationFrame(() => {
					swiperEls.forEach((swiperEl) => {
						this._setActive(swiperEl, true)
					})

					requestAnimationFrame(() => {
						swiperEls.forEach((swiperEl) => {
							swiperEl?.swiperCarousel?.update?.()
						})
					})
				})
			}

			_trackCurrentProduct() {
				const handle = this.dataset.productHandle
				if (!handle) return

				const storageKey = 'l-recently-viewed-products'
				const limit = parseInt(this.dataset.productsLimit || '10', 10)
				let handles = []

				try {
					handles = JSON.parse(localStorage.getItem(storageKey) || '[]')
				} catch (error) {
					handles = []
				}

				handles = handles.filter((storedHandle) => storedHandle !== handle)
				handles.unshift(handle)
				handles = handles.slice(0, limit)

				localStorage.setItem(storageKey, JSON.stringify(handles))
			}

			_checkRecentlyViewedAvailability() {
				const storageKey = 'l-recently-viewed-products'
				const currentHandle = this.dataset.productHandle
				let handles = []

				try {
					handles = JSON.parse(localStorage.getItem(storageKey) || '[]')
				} catch (error) {
					handles = []
				}

				handles = handles.filter((storedHandle) => storedHandle !== currentHandle)

				if (handles.length === 0) {
					this._hideRecentlyViewedTab()
				}
			}

			async _loadRecentlyViewed() {
				if (this._recentlyViewedLoaded || !this.recentlyViewedEl) return

				const storageKey = 'l-recently-viewed-products'
				const sectionId = this.dataset.sectionId
				const currentHandle = this.dataset.productHandle
				const limit = parseInt(this.dataset.productsLimit || '10', 10)
				let handles = []

				try {
					handles = JSON.parse(localStorage.getItem(storageKey) || '[]')
				} catch (error) {
					handles = []
				}

				handles = handles.filter((storedHandle) => storedHandle !== currentHandle).slice(0, limit)

				if (handles.length === 0) {
					this._hideRecentlyViewedTab()
					return
				}

				const query = handles.map((handle) => `handle:${handle}`).join(' OR ')
				const root = window.Shopify?.routes?.root || '/'
				const url = `${root}search?q=${encodeURIComponent(query)}&type=product&section_id=${sectionId}`

				try {
					const response = await fetch(url)
					const text = await response.text()
					const tempDiv = document.createElement('div')
					tempDiv.innerHTML = text
					const responseEl = tempDiv.querySelector('l-recently-viewed-response')

					if (!responseEl?.querySelector('.l-cPCard')) {
						this._hideRecentlyViewedTab()
						return
					}

					this.recentlyViewedEl.innerHTML = responseEl.innerHTML
					this._recentlyViewedLoaded = true
					this._reorderRecentlyViewedCards(handles)
					this._activatePanelSwiper('recently-viewed')
				} catch (error) {
					console.error('Failed to load recently viewed products:', error)
					this._hideRecentlyViewedTab()
				}
			}

			_reorderRecentlyViewedCards(handles) {
				const wrapper = this.recentlyViewedEl?.querySelector('.swiper-wrapper')
				if (!wrapper) return

				const cards = [...wrapper.querySelectorAll('.l-cPCard')]
				const cardsByHandle = new Map(
					cards.map((card) => {
						const link = card.querySelector('a[href*="/products/"]')
						const href = link?.getAttribute('href') || ''
						const handle = href.split('/products/')[1]?.split('/')[0]?.split('?')[0]
						return [handle, card]
					})
				)

				handles.forEach((handle) => {
					const card = cardsByHandle.get(handle)
					if (card) wrapper.appendChild(card)
				})
			}

			_hideRecentlyViewedTab() {
				const recentlyViewedTab = this.tabEls.find((tabEl) => tabEl.dataset.tabId === 'recently-viewed')
				const recentlyViewedPanel = this.panelEls.find((panelEl) => panelEl.dataset.tabId === 'recently-viewed')
				const recommendationsTab = this.tabEls.find((tabEl) => tabEl.dataset.tabId === 'recommendations')
				const recommendationsPanel = this.panelEls.find((panelEl) => panelEl.dataset.tabId === 'recommendations')

				recentlyViewedTab?.classList.add('is-hidden')
				recentlyViewedPanel?.classList.add('is-empty')

				if (
					recentlyViewedTab?.dataset.active === 'true' &&
					recommendationsTab &&
					recommendationsPanel &&
					recentlyViewedPanel
				) {
					this._setActive(recommendationsTab, true)
					this._setActive(recentlyViewedTab, false)
					recommendationsPanel.classList.remove('l-hidden')
					this._setActive(recommendationsPanel, true)
					recentlyViewedPanel.classList.add('l-hidden')
					this._setActive(recentlyViewedPanel, false)
					this._activatePanelSwiper('recommendations')
				}
			}
		}

		customElements.define('l-product-recommendations-tabs', LTAProductRecommendationsTabs)
	}

	if (!customElements.get('l-recently-viewed-products')) {
		class LTARecentlyViewedProducts extends HTMLElement {}
		customElements.define('l-recently-viewed-products', LTARecentlyViewedProducts)
	}

  } catch(e) { console.error(e); }
})();
})();
